/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_UnreadInputs */



/**
* | output |
* | --- |
* | "Wundo has replied" |
*
* @param {Chat_UnreadInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_unread = /** @type {((inputs?: Chat_UnreadInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_UnreadInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Wundo heeft geantwoord")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Wundo a répondu")
	return /** @type {LocalizedString} */ ("Wundo has replied")
});